import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { pathOr, propOr } from 'ramda';
import { Grid } from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';
import {
  BrandAsset,
  BrandBundleType,
  Matcher,
  DisplayLabels,
} from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantBrandAssets/MerchantBrandAssets.helpers';
import styles from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantBrandAssets/MerchantBrandAssets.styles';

import DefaultAssets from '../DefaultAssets';
import VenmoAssets from '../VenmoAssets';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
  brandAssets: BrandAsset;
  brandBundle: string;
};

const renderMatcher = (
  { type, pattern }: Matcher,
  idx: number,
  classes: Styles,
) => {
  const { BrandMatcherTypesLabels } = DisplayLabels as any;
  return (
    <li className={classes.brandMatcher} key={idx}>
      <span className={classes.brandMatcherType}>
        {BrandMatcherTypesLabels[type]},
      </span>
      <span>{pattern}</span>
    </li>
  );
};
const Tier1Layout: FunctionComponent<Props> = ({
  classes,
  brandAssets,
  brandBundle,
}) => {
  const { name, description, rawMatchers, rawPlaceMatchers } = brandAssets;

  const bundle = pathOr('', ['assets'], brandAssets);
  const brandMatchers = propOr([], 'matchers', rawMatchers) as string[];
  const placeMatchers = propOr([], 'matchers', rawPlaceMatchers) as string[];

  return (
    <Grid className={classes.grid}>
      <Grid.Row>
        <Grid.Column width={16}>
          <Grid.Row>
            <div className={classes.clientWrapper}>
              <img
                className={classes.clientLogo}
                src={pathOr('', ['icon', 'path'], bundle) as string}
              />
              <div className={classes.clientInfo}>
                <h2 className={classes.businessName}>{name}</h2>
              </div>
            </div>
          </Grid.Row>
          <Grid.Row>
            <p className={classes.brandDescription}>{description}</p>
          </Grid.Row>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8}>
          <div className={classes.fieldGroup}>
            <label className={classes.label}>Transaction Matchers:</label>
            <ul className={classes.brandMatchers}>
              {brandMatchers.map((matcher: any, idx) =>
                renderMatcher(matcher, idx, classes),
              )}
            </ul>
          </div>
        </Grid.Column>
        <Grid.Column width={8}>
          <div className={classes.fieldGroup}>
            <label className={classes.label}>Place Matchers:</label>
            <ul className={classes.brandMatchers}>
              {placeMatchers.map((matcher: any, idx) =>
                renderMatcher(matcher, idx, classes),
              )}
            </ul>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        {brandBundle === BrandBundleType.DEFAULTBRANDING && (
          <DefaultAssets brandAssets={brandAssets} />
        )}
        {brandBundle === BrandBundleType.VENMOAPP && (
          <VenmoAssets brandAssets={brandAssets} />
        )}
      </Grid.Row>
    </Grid>
  );
};

export default withStyles(styles)(Tier1Layout);
